<template>
  <div>
    <div class="flex mt-4">
      <div class="w-1/2">
        <p
          :class="[
            'text-md font-bold text-product-gray'
          ]"
        >
          {{ modifier[`name_${language}`] }}
        </p>
      </div>

      <div class="w-1/2 text-right">
        <p v-if="modifier.minSelectedAmount" class="text-xs">
          {{ lang["minimum_addition_selection"][language] }}:
          {{ modifier.minSelectedAmount }}
        </p>
        <p v-if="modifier.maxSelectedAmount > 0" class="text-xs">
          {{ lang["maximum_addition_selection"][language] }}:
          {{ modifier.maxSelectedAmount }}
        </p>
      </div>
    </div>

    <div
      :class="[
        'border-t-1 border-l-1 border-r-1 rounded-xl mt-2 border-border-gray borderlastChild',
        modifier.Additions.length > 5 && CurrentTheme == 'default'
          ? 'scrollbar-thumb-primary'
          : 'scrollbar-thumb-new-primary',
      ]"
    >
      <label
        :id="addition.Id"
        v-if="addition.isVisible"
        :class="['borderNone borderlastChild ']"
        v-for="addition in modifier.Additions"
        :key="addition.Id"
      >
        <div>
          <input
            @click="clickedOnModifier($event, addition, modifier)"
            v-model="selectedModifiers"
            class="mr-2 leading-tight input w-full hidden"
            :type="modifier.maxSelectedAmount == 1 ? 'radio' : 'checkbox'"
            :value="addition"
            :name="modifier[`name_${language}`]"
            :disabled="
              modifier.maxSelectedAmount != 0 &&
              selectedModifiers.length == modifier.maxSelectedAmount &&
              selectedModifiers.indexOf(addition) === -1
            "
          />

          <div
          :key="selectedModifiersArray.length"
            class="pr-4 py-2 borderAndRadius flex justify-between p-2 pl-6 border-b-1 border-border-gray transition duration-300"
            :style="
              selectedModifiersArray.includes(addition.Id)
                ? listsActiveBackground
                : listsBackground
            "
          >
            <div :class="['w-1/2 items-center flex']">
              <div class="block">
                <span
                :key="selectedModifiersArray.length"
                  :class="[
                    'font-semibold',
                    { active: isActive } /*[theme.body.textColor]*/,
                  ]"
                  :style="
                    selectedModifiersArray.includes(addition.Id)
                      ? listsActiveText
                      : listsText
                  "
                  >{{ addition[`name_${language}`] }}</span
                >
              </div>
            </div>

            <div class="flex">
              <div style="listsBackground">
                <label v-if="addition.price > 0">
                  <input
                    @click="
                      selectModifier(
                        modifier.AdditionGroupId,
                        addition.price,
                        addition.Id,
                        { modifier, addition }
                      )
                    "
                    v-model="selectedModifiers"
                    class="mr-2 leading-tight input hidden"
                    :type="
                      modifier.maxSelectedAmount == 1 ? 'radio' : 'checkbox'
                    "
                    :value="addition"
                    :name="modifier[`name_${language}`]"
                    :disabled="
                      modifier.maxSelectedAmount != 0 &&
                      selectedModifiers.length == modifier.maxSelectedAmount &&
                      selectedModifiers.indexOf(addition) === -1
                    "
                  />
                  <span
                    :class="[
                      'flex items-center p-1 justify-center rounded-xxl h-auto w-auto border-1 checked extra checkedPrice',
                      disableBackground,
                    ]"
                    :style="
                      selectedModifiersArray.includes(addition.Id)
                        ? listActivePrice
                        : ''
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      class="w-4 h-4"
                    >
                      <path
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        fill="none"
                        :stroke="selectedModifiersArray.includes(addition.Id) ? crossIconColor : selectItemColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p
                      v-if="addition.price > 0"
                      class="text-sm ml-2 font-semibold pr-1"
                      :style="
                        selectedModifiersArray.includes(addition.Id)
                          ? listsActiveText
                          : listsText
                      "
                    >
                      {{ currency }} {{ addition.price }}
                    </p>
                  </span>
                </label>
                <span
                  v-if="!addition.price"
                  :class="[
                    'flex items-center p-1 justify-center rounded-xxl h-auto w-auto border-1 checked2',
                    disableBackground,
                  ]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    class="w-4 h-4"
                  >
                    <path
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      fill="none"
                      :stroke="selectItemColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </label>
    </div>
    <div key="loader" class="w-full" v-show="isLoading">
        <SkeletonComboAdditions />
      </div>
    <div v-if="!isLoading && modifier.AdditionGroupId == comboDealAdditions.combogroupid">
      <div
        v-for="(modifierGroup, groupIndex) in comboDealAdditions.data"
        :key="modifierGroup.Id"
        class="allComboAdditions"
      >
        <ComboAdditions
          v-if="selectedModifiers.Id"
          :allSelectedModifiers="allSelectedModifiers"
          :modifier="modifier"
          :minModifierComboCount="minModifierComboCount"
          :modifierGroup="modifierGroup"
          :groupIndex="groupIndex"
        />
      </div>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import _ from "lodash";
import axios from "axios";
import ComboAdditions from "./ComboAdditions.vue";
import SkeletonComboAdditions from "./SkeletonLoaders/SkeletonComboAdditions.vue";


export default {
  components: {
    ComboAdditions,
    SkeletonComboAdditions,
  },
  props: {
    modifiers: {
      type: Array,
      required: true,
    },
    modifier: {
      type: Object,
      required: true,
    },
    isComboDeal: {
      type: Boolean,
      required: true,
    },
    allSelectedModifiers: {
      type: Array,
      required: true,
    },
    arrayNumber: Number,
  },
  data() {
    return {
      lodash: _,
      lang: lang,
      selectedModifiers: [],
      selectedComboModifiers: [],
      comboDealIndex: 0,
      comboGroupDealIndex: 0,
      // Temporary to keep the Ids to match with the theme.
      selectedModifiersArray: [],
      disableModifiers: false,
      modifiersMessage: "",
      disableBackground: "",
      isActive: false,
      CurrentTheme: localStorage.getItem("theme"),
      previeusAdditionPrice: 0,
      previeusAdditionId: 0,
      minSelected: 0,
      minselectedbool: true,
      lengthModifiersDiff: 0,
      radioButtonLength: false,
      currentGroupId: 0,
      categoryModifier: [],
      isLoading: false,
    };
  },
  watch: {
    selectedModifiers(currentValue) {
      // this returns all the current ID's from the additiongroup you click in
      let allmodifiers = this.modifier.Additions.map((x) => x.Id);
      if (this.minModifiersCheck.length) {
        // if the id's are not the same we know that its the first time we click on that addition group so we put that in the array so we can hold that data
        this.minModifiersCheck.map((x) => {
          if (x.id == this.modifier.AdditionGroupId) {
            x.minCount = 0;
          } else {
            if (this.modifier.minSelectedAmount != 0) {
              this.$store.commit("updateMinModifiersCheck", {
                id: this.modifier.AdditionGroupId,
                min: this.modifier.minSelectedAmount,
                minCount: 0,
                continue: false,
              });
              // we only want to store the same items 1 time in the array so we sort them out and store them
              this.$store.commit(
                "transformMinModifiersCheck",
                _.uniqBy(this.minModifiersCheck, "id")
              );
            }
          }
        });
      } else {
        if (this.modifier.minSelectedAmount != 0) {
          this.$store.commit("updateMinModifiersCheck", {
            id: this.modifier.AdditionGroupId,
            min: this.modifier.minSelectedAmount,
            minCount: 0,
            continue: false,
          });
        }
      }

      if (this.modifier.maxSelectedAmount == 1) {
        let objectId = { Id: this.selectedModifiers.Id };
        this.selectedModifiersArray = _.map(objectId, function (item) {
          return item;
        });
        // return (this.selectedModifiersArray += this.selectedModifiers.Id);
      } else {
        this.selectedModifiersArray = _.map(
          this.selectedModifiers,
          function (item) {
            return item.Id;
          }
        );
      }

      /** Disable add to cart button disabled when minimum one modifiers is allowed. */
      if (this.modifier.minSelectedAmount == 1) {
        if (this.modifier.maxSelectedAmount == 1) {
          let radioBtnCurrentValue = [currentValue];
          if (radioBtnCurrentValue.length >= this.modifier.minSelectedAmount) {
            if (radioBtnCurrentValue[0].Id && !this.radioButtonLength) {
              //refactor this function in later stadium / this keeps the right number of selected MIN additions
            } else {
              this.radioButtonLength = false;
              this.$store.commit(
                "updateMinSelectedAdditionTotal",
                this.minSelectedAdditionTotal - 1
              );
            }
            if (radioBtnCurrentValue[0].Id) {
              this.radioButtonLength = true;
              this.$store.commit(
                "updateMinSelectedAdditionTotal",
                this.minSelectedAdditionTotal + 1
              );
            }
            this.modifiersMessage = "";
          } else {
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
          if (currentValue.length == 0) {
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
        } else {
          //updates the mincount in the array so we know how many additions we clicked
          currentValue.map((x) =>
            this.minModifiersCheck.map((y) => {
              if (y.id == x.AdditionGroupId) {
                y.minCount += 1;
              }
            })
          );
          if (currentValue.length && !this.radioButtonLength) {
            //refactor this function in later stadium / this keeps the right number of selected MIN additions
          } else {
            this.radioButtonLength = false;
          }
          if (currentValue.length) {
            this.radioButtonLength = true;
          }
          if (currentValue.length >= this.modifier.minSelectedAmount) {
            this.modifiersMessage = "";
          } else {
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
        }
      }

      if (this.modifier.minSelectedAmount > 1) {
        if (
          this.minSelected == this.modifier.minSelectedAmount ||
          !this.minselectedbool
        ) {
          //     //refactor this function in later stadium / this keeps the right number of selected MIN additions
        }
        if (currentValue.length) {
          this.radioButtonLength = true;
          this.minSelected += 1;
        }
        let currentModifiers = this.selectedModifiersArray;
        let lengthModifiers = _.difference(
          allmodifiers,
          currentModifiers
        ).length;
        this.lengthModifiersDiff = allmodifiers.length - lengthModifiers;
        //updates the mincount in the array so we know how many additions we clicked
        currentValue.map((x) =>
          this.minModifiersCheck.map((y) => {
            if (y.id == x.AdditionGroupId) {
              y.minCount += 1;
            }
          })
        );
      }

      /** In Case when Unlimited Modifieres are allowed */
      if (this.modifier.maxSelectedAmount == -1) {
        this.$store.commit("updateModifierNumber", 0);
        this.modifiersMessage =
          this.lang["multiple_modifiers_can_be_selected"][this.language];
        return (this.disableModifiers = false), (this.disableBackground = "");
      }

      if (this.modifier.maxSelectedAmount == 1) {
        this.$store.commit("updateModifierNumber", 1);
        /** When one modifier is selected then disable the further selection. */
        if (currentValue.length == 1) {
          this.modifiersMessage =
            this.lang["only_one_modifier_allowed"][this.language];
          this.disableBackground = "opacity-30";
          return (this.disableModifiers = true);
        } else {
          return (this.disableModifiers = false), (this.disableBackground = "");
        }
      }
      this.$store.commit("updateModifierNumber", 0);
      return (this.disableModifiers = false), (this.disableBackground = "");
    },
    comboItemSelectionStep(value) {
      if (
        this.modifiers[value].AdditionGroupId ==
        this.selectedModifiers?.AdditionGroupId
      ) {
        this.isLoading = true;
        axios
          .get(
            `${process.env.VUE_APP_API_BASE_PATH}/GetComboDealItemAdditions?MenuHash=${this.menuHash}&AdditionId=${this.selectedModifiers.Id}`
          )
          .then((response) => {
            if (
              (this.minModifierComboCount !=
                this.minSelectedAdditionComboTotal &&
                this.modifier.maxSelectedAmount <= 1 &&
                this.comboDealAdditions.combogroupid ==
                  response.data.combo_group_id) ||
              this.minModifierComboCount == 0 ||
              this.minModifierComboCount == this.minSelectedAdditionComboTotal
            ) {
              this.categoryModifier = response.data.Modifiers;
              let obj = {
                combogroupid: response.data.combo_group_id,
                data: response.data.Modifiers,
              };
              this.$store.commit("Cart/updateComboDealAdditions", obj);
              this.$store.commit("Cart/updateComboDealAdditions", obj);
              if (!response.data.Modifiers.length) {
                this.$store.commit("updateMinModifierComboCount", 0);
              } else {
                let minModifierComboCount = 0;
                response.data.Modifiers.map((x) => {
                  if (
                    (x.minSelectedAmount > 0 && x.maxSelectedAmount > 0) ||
                    (x.minSelectedAmount > 0 && x.maxSelectedAmount == -1)
                  ) {
                    minModifierComboCount++;
                  }
                });
                this.$store.commit(
                  "updateMinModifierComboCount",
                  minModifierComboCount
                );
                let selectedModifiersGroupIds = this.allSelectedModifiers.map(
                  (el) => el.AdditionGroupId
                );
                let minSelectedAdditionComboTotal = 0;
                response.data.Modifiers.forEach((element) => {
                  if (
                    selectedModifiersGroupIds.includes(
                      element.AdditionGroupId
                    ) &&
                    element.minSelectedAmount > 0
                  ) {
                    minSelectedAdditionComboTotal += element.minSelectedAmount;
                  }
                });
                this.$store.commit(
                  "updateMinSelectedAdditionComboTotal",
                  minSelectedAdditionComboTotal
                );
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      }
    },
  },
  methods: {
    clickedOnModifier($event, addition, modifier) {
      if (this.isComboDeal) {
        /** if already selected then clicked to unselect list and do not call API*/
        if (addition.Id == this.previeusAdditionId) {
          if (modifier.maxSelectedAmount == 1) {
            this.uncheck(
              $event,
              addition.Id,
              addition.price,
              modifier.AdditionGroupId
            );
          }
        } else {
          this.getComboDealAdditions(modifier, addition);
        }
      } else {
        this.selectModifier(
          modifier.AdditionGroupId,
          addition.price,
          addition.Id,
          { modifier, addition }
        );
      }
      if (!this.isComboDeal && modifier.maxSelectedAmount == 1) {
        this.uncheck($event, addition.Id, addition.price);
      }
    },
    giveComboDealId(index, groupIndex) {
      this.comboDealIndex = index;
      this.comboGroupDealIndex = groupIndex;
    },
    getComboDealAdditions(modifier, addition) {
      let id = addition.Id;
      this.isLoading = true;
      axios
        .get(
          `${process.env.VUE_APP_API_BASE_PATH}/GetComboDealItemAdditions?MenuHash=${this.menuHash}&AdditionId=${id}`
        )
        .then((response) => {
            let obj = {
              combogroupid: response.data.combo_group_id,
              data: response.data.Modifiers,
            };
            this.$store.commit("Cart/updateComboDealAdditions", obj);
            if (!response.data.Modifiers.length) {
              this.$store.commit("updateMinModifierComboCount", 0);
            } else {
              let minModifierComboCount = 0;
              response.data.Modifiers.map((x) => {
                if (
                  (x.minSelectedAmount > 0 && x.maxSelectedAmount > 0) ||
                  (x.minSelectedAmount > 0 && x.maxSelectedAmount == -1)
                ) {
                  minModifierComboCount++;
                }
              });
              this.$store.commit(
                "updateMinModifierComboCount",
                minModifierComboCount
              );
            }
            this.$store.commit("updateMinSelectedAdditionComboTotal", 0);
            this.$store.commit("deleteMinModifiersCheck");

            /** select only if its valid for selection */
            this.selectModifier(
              modifier.AdditionGroupId,
              addition.price,
              addition.Id,
              { modifier, addition }
            );
            this.previeusAdditionId = id;
            this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    uncheck(event, id, price, modifierGroupId) {
      if (id != this.previeusAdditionId) {
        this.$store.commit(
          "updateItemPrice",
          this.itemPrice - this.previeusAdditionPrice
        );
        this.previeusAdditionId = id;
        this.previeusAdditionPrice = price;
      } else {
        this.previeusAdditionId = 0;
        this.previeusAdditionPrice = 0;
      }
      if (this.selectedModifiersArray.includes(id) == true) {
        event.target.checked = false;
        /** if item is unchecked remove the ComboDealAdditions
         * and updateMinModifierComboCount  to zero
         */
        this.$store.commit("updateMinModifierComboCount", 0);
        this.$store.commit("Cart/updateComboDealAdditions", []);
        this.selectedModifiers = [];
        this.selectedModifiersArray.splice(0, id);
        if (modifierGroupId) {
          setTimeout(() => {
            window.$eventBus.$emit("additions-selected", {
              modifierGroupId: modifierGroupId,
              comboDealId: this.modifier.combo_deal_item_id,
              selectedModifiers: [],
            });
          }, 100);
        }
      }
    },
    selectModifier(modifierGroupId, price, id, data) {
      if (this.modifier.minSelectedAmount > 1) {
        if (this.lengthModifiersDiff <= this.modifier.minSelectedAmount) {
          //updates the mincount in the array so we know how many additions we clicked
          if (this.selectedModifiersArray.includes(id) == true) {
            this.minModifiersCheck.map((y) => {
              if (y.id == modifierGroupId) {
                y.minCount -= 1;
              }
            });
          }
        }
      }
      if (data.addition.combo_deal_item_id) {
        setTimeout(() => {
          window.$eventBus.$emit("additions-selected", {
            modifierGroupId: data.modifierGroup.AdditionGroupId,
            comboDealId: this.modifier.combo_deal_item_id,
            selectedModifiers: this.selectedComboModifiers,
          });
        }, 100);
      } else if (
        (this.minModifierComboCount != this.minSelectedAdditionComboTotal &&
          this.comboDealAdditions.combogroupid ==
            this.selectedModifiers.AdditionGroupId) ||
        this.minModifierComboCount == 0 ||
        this.minModifierComboCount == this.minSelectedAdditionComboTotal ||
        !this.selectedModifiers?.Id
      ) {
        setTimeout(() => {
          window.$eventBus.$emit("additions-selected", {
            modifierGroupId: modifierGroupId,
            comboDealId: this.modifier.combo_deal_item_id,
            selectedModifiers: this.selectedModifiers,
          });
        }, 100);
      }

      if (this.arrayNumber > 0) {
        for (let i = 0; this.arrayNumber > i; i++) {
          const additions = document.querySelectorAll(`.allAdditions`)[i];
          const specificAdditions = additions.querySelectorAll(
            ".AdditionItemWrapper--open"
          );
          specificAdditions.forEach((a) => {
            a.classList.add("AdditionItemWrapper--closed");
            a.classList.remove("AdditionItemWrapper--open");
          });
        }
      }
    },
    handleChangeEmit() {
      this.$emit("change", {
        additionGroup: this.modifier,
        additions: Array.isArray(this.selectedModifiers)
          ? this.selectedModifiers.map((d) => ({ Addition: d }))
          : { Addition: this.selectedModifiers },
      });
    },
    handleChange() {
      this.$emit("change", {
        additionGroup: this.modifier,
        additions: Array.isArray(this.selectedComboModifiers[0])
          ? this.selectedComboModifiers[0].map((d) => ({ Addition: d }))
          : { Addition: this.selectedComboModifiers[0] },
      });
    },
  },
  computed: {
    ...mapGetters([
      "itemPrice",
      "minModifiersCheck",
      "minSelectedAddition",
      "minSelectedAdditionTotal",
      "language",
      "currency",
      "theme",
      "minSelectedAddition",
      "minSelectedAdditionTotal",
      "menuHash",
      "minSelectedAdditionComboTotal",
      "minModifierComboCount",
      "comboItemSelectionStep",
    ]),
    ...mapGetters("Cart", ["comboDealAdditions"]),
    ...mapGetters("Theme", [
      "listsText",
      "listsBackground",
      "listsActiveText",
      "listsActiveBackground",
      "btnOutlineBorder",
      "btnOutlineText",
      "btnOutlineBackground",
      "btnOutlineIcon",
      "btnOutlineActiveBorder",
      "btnOutlineActiveText",
      "btnOutlineActiveBackground",
      "btnOutlineActiveIcon",
      "listActivePrice",
      "listActivePriceText",
      "selectItemColor",
      "crossIconColor",
    ]),
  },
  mounted() {
    this.$store.commit("updateMinSelectedAdditionTotal", 0);
    this.$store.commit("deleteMinModifiersCheck");
    if (this.modifier.minSelectedAmount >= 1) {
      return (this.modifiersMessage =
        this.lang["minimum_one_item_is_required"][this.language]);
    }
    if (this.modifier.maxSelectedAmount == -1) {
      this.modifiersMessage =
        this.lang["multiple_modifiers_can_be_selected"][this.language];
    }
    if (this.modifier.maxSelectedAmount == 1) {
      this.modifiersMessage =
        this.lang["only_one_modifier_allowed"][this.language];
    }
  },
  updated() {
    // if the mincount >= than the minSelectedAmount we set the continue to true so we know that there are enough additions selected
    this.minModifiersCheck.map((x) => {
      if (this.modifier.AdditionGroupId == x.id) {
        if (x.minCount >= this.modifier.minSelectedAmount) {
          x.continue = true;
        } else {
          x.continue = false;
        }
      }
    });
  },
};
</script>

<style scoped>
.borderNone:last-of-type div {
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.borderNone:first-of-type div {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.borderNone:last-of-type .checked2,
.borderNone:last-of-type .checkedPrice {
  border-radius: 15px;
}
.input + .checked {
  transition: all 0.3s;
}
.input + .checked img {
  transition: all 0.3s;
}
.input:checked + .checked svg {
  transform: rotate(45deg);
}
.input:checked + .extra {
  border-radius: 2rem;
}
.borderNone:first-of-type .input:checked + .extra {
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
}
.borderNone:last-of-type .input:checked + .extra {
  border-bottom-left-radius: 2rem;
  border-bottom-right-radius: 2rem;
}
.borderNone:first-of-type .input:checked + div {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.borderNone:last-of-type .input:checked + div {
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.input:checked + div .checked2 {
  /* display: none; */
  transform: rotate(45deg);

}
.input + div:hover {
  cursor: pointer;
}
</style>
